import { queriesPayouts } from "@query";
import { useSession } from "@hooks/useSession";
import {
  PayoutSettings,
  PayoutSettingsList,
  ResponseError
} from "@wingspanhq/wingspan-api-sdk";
import { WSQueryConfig } from "@ws-react-query";
import { selectorOwnPayoutSettings } from "@selectors/selectorOwnPayoutSettings";

export const useQueryOwnPayoutSettings = (
  config?: Omit<
    WSQueryConfig<
      PayoutSettingsList,
      ResponseError,
      PayoutSettings | undefined
    >,
    "select"
  >
) => {
  const { accountId } = useSession();

  return queriesPayouts.listPayoutSettings.useQuery(undefined, {
    enabled: !!accountId,
    ...config,
    select: selectorOwnPayoutSettings
  });
};
